//@ts-ignore
import App from "./App.vue";
import Vue from "vue";
import router from "@/router/router";
import store from "./store/store";
import vuetify from "./plugins/vuetify";
import VueCookies from "vue-cookies";
import { VNode } from "vue/types/umd";
import FadeScroll from '@/directives/fadeScroll';
import "./plugins/vue-currency-input";
import "./assets/styles/global.scss";
import "./assets/styles/formControls.scss";
import '@mdi/font/css/materialdesignicons.css'

Vue.directive('fade-scroll', FadeScroll);
Vue.use(VueCookies);
Vue.$cookies.config('30d')
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h): VNode => h(App),
}).$mount("#app");

const EventBus = new Vue();
export default EventBus;

